import { CustomLabels } from './custom-labels';

const printDefaultLabels = () => {
    console.log(JSON.stringify(DefaultLabels));
}
// return JSON.parse(DefaultLabels);
// throw "t"


export const DefaultLabels: Required<CustomLabels> = {
    RessourcePlan: {
        wordBinding: 'Ressourcenplan',
        Nominativ: {
            singular: {
                article: 'der',
                value: 'Ressourcenplan',
            },
            plural: {
                article: 'die',
                value: 'Ressourcenpläne',
            }
        }
    },
    // wird ggf. im service überschrieben
    Commission: {
        wordBinding: 'Auftrags',
        Nominativ: {
            singular: {
                article: 'der',
                value: 'Auftrag',
            },
            plural: {
                article: 'die',
                value: 'Aufträge',
            },
        },
        Genitiv: {
            singular: {
                article: 'des',
                value: 'Auftrags',
            },
            plural: {
                article: 'der',
                value: 'Aufträge',
            },
        },
        Dativ: {
            singular: {
                article: 'dem',
                value: 'Auftrag',
            },
            plural: {
                article: 'den',
                value: 'Aufträgen',
            },
        },
    },
    CommissionInternalNumber: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Interne Nummer',
            },
            plural: {
                article: 'die',
                value: 'Internen Nummern',
            }
        }
    },
    CommissionInternalNumberShort: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Interne Nr.',
            },
            plural: {
                article: 'die',
                value: 'Internen Nr.',
            }
        }
    },

    Department: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Abteilung',
            },
            plural: {
                article: 'die',
                value: 'Abteilungen',
            }
        }
    },
    ExecutingDepartment: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'ausführende Abteilung',
            },
            plural: {
                article: 'die',
                value: 'ausführende Abteilungen',
            }
        }
    },

    // wird ggf im service überschrieben
    Customer: {
        wordBinding: 'Kunden',
        Nominativ: {
            singular: {
                article: 'der',
                value: 'Kunde',
            },
            plural: {
                article: 'die',
                value: 'Kunden',
            }
        },
        Dativ: {
            singular: {
                article: 'der',
                value: 'Kunde',
            },
            plural: {
                article: 'die',
                value: 'Kunden',
            }
        }
    },
    // wird im service überschrieben
    CustomerNumber: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Kundennummer',
            },
            plural: {
                article: 'die',
                value: 'Kundennummern',
            }
        }
    },
    // wird im service überschrieben
    CustomerSpecificationType: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Kundenart',
            },
            plural: {
                article: 'die',
                value: 'Kundenarten',
            }
        }
    },
    CustomerNumberShort: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Kunden Nr.',
            },
            plural: {
                article: 'die',
                value: 'Kunden Nr.',
            }
        }
    },
    CustomerDescription: {
        "Nominativ": {
            "singular": {
                "article": "der",
                "value": "Firma Zusatz"
            },
            "plural": {
                "article": "die",
                "value": "Firmen Zusätze"
            }
        }
    },
    CustomerName: {
        "Nominativ": {
            "singular": {
                "article": "die",
                "value": "Firma"
            },
            "plural": {
                "article": "die",
                "value": "Firmen"
            }
        }
    },
    SupplierDescription: {
        "Nominativ": {
            "singular": {
                "article": "der",
                "value": "Lieferant Zusatz"
            },
            "plural": {
                "article": "die",
                "value": "Lieferanten Zusätze"
            }
        }
    },
    SupplierName: {
        "Nominativ": {
            "singular": {
                "article": "der",
                "value": "Lieferant"
            },
            "plural": {
                "article": "die",
                "value": "Lieferanten"
            }
        }
    },
    // wird im service überschrieben
    CommissionFreeTextField1: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Allg. Info zum Auftrag',
            },
            plural: {
                article: 'die',
                value: 'Allg. Infos zum Auftrag',
            }
        }
    },
    // wird im service überschrieben
    CommissionCompleteBusinessVolume: {
        Nominativ: {
            singular: {
                article: 'der',
                value: 'Geplanter Umsatz (Netto)',
            },
            plural: {
                article: 'die',
                value: 'Geplanten Umsätze (Netto)',
            }
        }
    },
    CommissionPlannedStartDate: {
        Nominativ: {
            singular: {
                article: 'das',
                value: 'Geplantes Startdatum',
            },
            plural: {
                article: 'die',
                value: 'Geplanten Startdaten',
            }
        }
    },
    CommissionDescription: {
        Nominativ: {
            singular: {
                article: 'der',
                value: 'Titel',
            },
            plural: {
                article: 'die',
                value: 'Titel',
            }
        }
    },
    CommissionOfferSubmissionDate: {
        Nominativ: {
            singular: {
                article: 'die',
                value: 'Angebotsabgabe',
            },
            plural: {
                article: 'die',
                value: 'Angebotsabgaben',
            }
        }
    }
}

printDefaultLabels();
